import { useState } from "react";
import { Link } from "react-router-dom";
import { EnvelopeSimple } from "@phosphor-icons/react";
import { forgotPassword, formatApiErrorDetail } from "../lib/api";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");
    try {
      await forgotPassword(email);
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err?.response?.data?.detail));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div data-testid="forgot-password-page" className="mx-auto flex min-h-[80vh] max-w-sm flex-col justify-center px-4 py-16">
      <div className="mb-8 text-center">
        <Link to="/" className="font-heading text-2xl font-black uppercase tracking-tighter text-white">
          EDGE<span className="text-eb-accent">BALL</span>
        </Link>
        <h1 className="mt-4 font-heading text-xl uppercase tracking-tight text-white">Reset Password</h1>
      </div>

      {sent ? (
        <p data-testid="forgot-password-sent-message" className="rounded-md border border-green-500/30 bg-green-500/10 px-4 py-3 text-center text-sm text-green-400">
          If that email exists, a reset link has been sent. Check your inbox.
        </p>
      ) : (
        <form onSubmit={handleSubmit} className="flex flex-col gap-3 rounded-lg border border-white/10 bg-eb-surface p-6">
          {error && (
            <p data-testid="forgot-password-error" className="rounded-md border border-red-500/30 bg-red-500/10 px-3 py-2 text-sm text-red-400">
              {error}
            </p>
          )}
          <p className="text-sm text-zinc-500">Enter your account email and we&rsquo;ll send you a link to reset your password.</p>
          <input
            data-testid="forgot-password-email-input"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            className="rounded-md border border-white/10 bg-eb-bg px-3 py-2 text-sm text-white placeholder:text-zinc-600 focus:border-eb-accent focus:outline-none"
          />
          <button
            data-testid="forgot-password-submit-button"
            type="submit"
            disabled={submitting}
            className="mt-2 flex items-center justify-center gap-2 rounded-md bg-eb-accent px-4 py-2 font-heading text-sm uppercase tracking-wide text-white transition-colors hover:bg-blue-600 disabled:opacity-50"
          >
            <EnvelopeSimple size={16} weight="bold" /> {submitting ? "Sending\u2026" : "Send Reset Link"}
          </button>
        </form>
      )}
      <p className="mt-4 text-center text-sm text-zinc-500">
        <Link to="/login" data-testid="forgot-password-login-link" className="text-eb-accent hover:underline">
          Back to Log In
        </Link>
      </p>
    </div>
  );
};

export default ForgotPassword;
